export default (event) => {

    try {
        event.guests.guestFields.forEach((f) => {
            if(f.type === 'enum'){
                if(typeof f.options === 'undefined') f.options = ''
            }
        })
    }catch (e) {
        console.log('sanitize guestFields: '+ e)
    }
    try {
        event.guests.companiesFields.forEach((f) => {
            if(f.type === 'enum'){
                if(typeof f.options === 'undefined') f.options = ''
            }
        })
    }catch (e) {
        console.log('sanitize companiesFields: '+ e)
    }

    if(event.status === 'removed') event.status = 'trash'

    return event
}
